export const form = {
  date: 'Active time',
} as const
